import React, { useState, Children } from 'react';
import { X } from 'lucide-react';
export function Footer() {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showAdvertorialModal, setShowAdvertorialModal] = useState(false);
  return <>
      <footer className="border-t border-gray-200 bg-gray-50 mt-16" data-id="element-48">
        <div className="max-w-7xl mx-auto px-4 py-8" data-id="element-49">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-50">
            <div className="text-sm text-gray-600" data-id="element-51">
              © 2025 NewsBreak. All rights reserved.
            </div>
            <div className="flex flex-wrap gap-6 text-sm" data-id="element-52">
              
              <button onClick={() => setShowPrivacyModal(true)} className="text-gray-600 hover:text-gray-900 underline decoration-gray-400" data-id="element-53">
                Privacy Policy
              </button>
              <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-54">
                Terms of Service
              </a>
              
            </div>
          </div>
        </div>
      </footer>

      {/* Advertorial Modal */}
      {showAdvertorialModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-55">
          <div className="bg-white rounded-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" data-id="element-56">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center" data-id="element-57">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-58">
                Advertorial Disclosure
              </h2>
              <button onClick={() => setShowAdvertorialModal(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-59">
                <X className="w-6 h-6" data-id="element-60" />
              </button>
            </div>
            <div className="px-6 py-6 space-y-4 text-gray-700 leading-relaxed" data-id="element-61">
              <p className="font-semibold text-gray-900" data-id="element-62">
                Important Notice: This is Sponsored Content
              </p>
              <p data-id="element-63">
                This article is an advertorial and has been created in
                partnership with HEYLLOYD. The content, opinions, and
                recommendations expressed in this article are those of the
                sponsor and do not necessarily reflect the views of NewsBreak or
                its editorial team.
              </p>
              <p data-id="element-64">
                <strong data-id="element-65">What is an Advertorial?</strong>
                <br data-id="element-66" />
                An advertorial is a form of advertisement designed to look and
                read like editorial content. While we strive to maintain
                transparency, advertorials are paid content created to promote a
                product, service, or brand.
              </p>
              <p data-id="element-67">
                <strong data-id="element-68">Our Commitment to Transparency:</strong>
                <br data-id="element-69" />
                NewsBreak is committed to clearly distinguishing between
                editorial content and sponsored content. All advertorials are
                clearly marked and disclosed to our readers. We maintain
                editorial independence and do not allow sponsors to influence
                our independent journalism.
              </p>
              <p data-id="element-70">
                <strong data-id="element-71">Compensation Disclosure:</strong>
                <br data-id="element-72" />
                NewsBreak receives compensation for publishing this advertorial
                content. This compensation may include direct payment, affiliate
                commissions, or other forms of consideration. Any links to
                external websites may be affiliate links where we earn a
                commission on qualifying purchases or actions.
              </p>
              <p data-id="element-73">
                <strong data-id="element-74">Your Responsibility:</strong>
                <br data-id="element-75" />
                We encourage readers to conduct their own research and due
                diligence before making any purchasing decisions based on
                advertorial content. The information provided is for
                informational purposes only and should not be considered
                professional advice.
              </p>
              <p className="text-sm text-gray-600 border-t border-gray-200 pt-4 mt-4" data-id="element-76">
                Last updated: January 2025
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Policy Modal */}
      {showPrivacyModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-77">
          <div className="bg-white rounded-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" data-id="element-78">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center" data-id="element-79">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-80">
                Privacy Policy
              </h2>
              <button onClick={() => setShowPrivacyModal(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-81">
                <X className="w-6 h-6" data-id="element-82" />
              </button>
            </div>
            <div className="px-6 py-6 space-y-4 text-gray-700 leading-relaxed" data-id="element-83">
              <p className="font-semibold text-gray-900" data-id="element-84">
                Effective Date: January 1, 2025
              </p>

              <div className="space-y-4" data-id="element-85">
                <section data-id="element-86">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-87">
                    1. Information We Collect
                  </h3>
                  <p data-id="element-88">
                    We collect information you provide directly to us, such as
                    when you create an account, subscribe to our newsletter, or
                    interact with our content. This may include your name, email
                    address, location preferences, and reading history.
                  </p>
                </section>

                <section data-id="element-89">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-90">
                    2. How We Use Your Information
                  </h3>
                  <p data-id="element-91">We use the information we collect to:</p>
                  <ul className="list-disc list-inside ml-4 space-y-1" data-id="element-92">
                    <li data-id="element-93">Provide, maintain, and improve our services</li>
                    <li data-id="element-94">Personalize your content experience</li>
                    <li data-id="element-95">Send you newsletters and updates</li>
                    <li data-id="element-96">Analyze usage patterns and trends</li>
                    <li data-id="element-97">Detect and prevent fraud or abuse</li>
                  </ul>
                </section>

                <section data-id="element-98">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-99">
                    3. Information Sharing
                  </h3>
                  <p data-id="element-100">
                    We do not sell your personal information. We may share your
                    information with:
                  </p>
                  <ul className="list-disc list-inside ml-4 space-y-1" data-id="element-101">
                    <li data-id="element-102">Service providers who assist in our operations</li>
                    <li data-id="element-103">Analytics partners to understand usage patterns</li>
                    <li data-id="element-104">Law enforcement when required by law</li>
                    <li data-id="element-105">Business partners with your explicit consent</li>
                  </ul>
                </section>

                <section data-id="element-106">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-107">
                    4. Cookies and Tracking
                  </h3>
                  <p data-id="element-108">
                    We use cookies and similar tracking technologies to collect
                    information about your browsing activities. You can control
                    cookies through your browser settings, though some features
                    may not function properly if cookies are disabled.
                  </p>
                </section>

                <section data-id="element-109">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-110">
                    5. Your Rights
                  </h3>
                  <p data-id="element-111">You have the right to:</p>
                  <ul className="list-disc list-inside ml-4 space-y-1" data-id="element-112">
                    <li data-id="element-113">Access and review your personal information</li>
                    <li data-id="element-114">Request correction of inaccurate data</li>
                    <li data-id="element-115">Request deletion of your data</li>
                    <li data-id="element-116">Opt-out of marketing communications</li>
                    <li data-id="element-117">Export your data in a portable format</li>
                  </ul>
                </section>

                <section data-id="element-118">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-119">
                    6. Data Security
                  </h3>
                  <p data-id="element-120">
                    We implement reasonable security measures to protect your
                    information from unauthorized access, alteration, or
                    destruction. However, no internet transmission is completely
                    secure, and we cannot guarantee absolute security.
                  </p>
                </section>

                <section data-id="element-121">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-122">
                    7. Children's Privacy
                  </h3>
                  <p data-id="element-123">
                    Our services are not directed to children under 13. We do
                    not knowingly collect personal information from children
                    under 13. If you believe we have collected such information,
                    please contact us immediately.
                  </p>
                </section>

                <section data-id="element-124">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-125">
                    8. Changes to This Policy
                  </h3>
                  <p data-id="element-126">
                    We may update this privacy policy from time to time. We will
                    notify you of any material changes by posting the new policy
                    on this page and updating the effective date.
                  </p>
                </section>

                <section data-id="element-127">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-128">
                    9. Contact Us
                  </h3>
                  <p data-id="element-129">
                    If you have questions about this privacy policy or our data
                    practices, please contact us at:
                  </p>
                  <p className="ml-4 mt-2" data-id="element-130">
                    Email: privacy@newsbreak.com
                    <br data-id="element-131" />
                    Address: 123 News Street, San Francisco, CA 94102
                  </p>
                </section>
              </div>

              <p className="text-sm text-gray-600 border-t border-gray-200 pt-4 mt-6" data-id="element-132">
                Last updated: January 2025
              </p>
            </div>
          </div>
        </div>}
    </>;
}